(function ($) {
    var $toolbarMenu = $(".toolbar-menu");
    var $toolbarMenuBlackout = $(".toolbar-menu-blackout");

    var toggleMenu = function () {
        $toolbarMenu.fadeToggle(200);
        $toolbarMenuBlackout.fadeToggle(200);
        $toolbarMenu.children(".toolbar-menu-group").removeClass("expanded");
        $toolbarMenu.children(".toolbar-menu-group").show();
        $('body').toggleClass('fixed')
    };

    $(".toolbar-menu-button").click(toggleMenu);
    $toolbarMenuBlackout.click(toggleMenu);

    $(".toolbar-menu-group").click(function() {
        $(this).toggleClass("expanded");
        $(this).siblings().toggle();
    });

    $("#site-nav-hamburger").click(function() {
        $('#site-nav-menu').removeClass("inactive");
    });
    $("#site-nav-underlay").click(function() {
        $('#site-nav-menu').addClass("inactive");
    });

    $('body').on('click', '#site-nav-hamburger', function(){
      $('body').toggleClass('fixed')
    });
 
    $("#site-nav-underlay").click(function() {
        $('body').toggleClass('fixed')
    });

})(jQuery);